<template>
  <b-card>
    <b-row>
      <b-col md="9">
        Toplam Seçilen Ürün {{ _selectedProducts.length }} adettir.
      </b-col>
      <b-col md="3">
        <b-button-group size="sm">
          <b-button :disabled="_selectedProducts.length<2" variant="primary" @click="addNewProduct($event,1)">
            <feather-icon icon="PackageIcon"></feather-icon>
            Grup Oluştur
          </b-button>
          <b-button :disabled="_selectedProducts.length!==1" variant="info" @click="addNewProduct2x($event,1)">
            <feather-icon icon="CopyIcon"></feather-icon>
            Çoklu Oluştur
          </b-button>
          <b-button :disabled="_selectedProducts.length<1" variant="danger"
                    @click="$store.state.productV2.selectedProducts = []">
            <feather-icon icon="XCircleIcon"></feather-icon>
            Seçim Temizle
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: 'SelectedProducts',
  computed: {
    ...mapGetters('productV2', ['_selectedProducts'])
  },
  methods: {
    addNewProduct2x(event, isBundle) {
      this.$swal({
        title: 'Kay Sayı Seçiniz',
        input: 'number',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        inputAttributes: {
          autocapitalize: 'off',
        },
        showCancelButton: true,
        confirmButtonText: 'Ekle',
        showLoaderOnConfirm: true,
        preConfirm: (multiple) => {
          if (!multiple) return null
          this.$store.state.productV2.selectedProducts[0].multiple = multiple
          this.$store.commit('product/setEditProduct', {isBundle, multiple, sub_products: this._selectedProducts});
          this.$root.$emit('bv::show::modal', 'edit-product-modal', event.target)
        },
      })
    },
    addNewProduct(event, isBundle) {
      this.$store.commit('product/setEditProduct', {isBundle, sub_products: this._selectedProducts});
      this.$root.$emit('bv::show::modal', 'edit-product-modal', event.target)
    },
  }
}
</script>